"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasicAi = void 0;
const AbilityArgs_1 = require("../../core/abilities/AbilityArgs");
const EffectType_1 = require("../../core/effects/EffectType");
const enums_1 = require("../../core/enums");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Random_1 = require("../../utils/Random");
let BasicAi = class BasicAi {
    init(sequence, container, state) {
        container.registerAiEventHandler(state.selfId, EventType_1.EventType.Damaged, Schedule_1.Schedule.Unlimited, state.selfId);
        container.registerAiEventHandler(state.selfId, EventType_1.EventType.Tick, Schedule_1.Schedule.Unlimited, state.selfId);
        const { onAdded, onTurnStarted, eventHandlers = [] } = state.args;
        if (onAdded) {
            container.registerEventHandlerScript(state.selfId, EventType_1.EventType.ActorEnabled, Schedule_1.Schedule.Once(), onAdded.key, onAdded.args);
        }
        if (onTurnStarted) {
            container.registerEventHandlerScript(state.selfId, EventType_1.EventType.TurnStarted, Schedule_1.Schedule.Unlimited, onTurnStarted.key, onTurnStarted.args);
        }
        eventHandlers === null || eventHandlers === void 0 ? void 0 : eventHandlers.forEach(({ event, schedule = Schedule_1.Schedule.Unlimited, handler }) => container.registerEventHandlerScript(state.selfId, event, schedule, handler.key, handler.args));
    }
    handleEvent(sequence, container, state, e) {
        switch (e.args.__type) {
            case EventType_1.EventType.Tick: {
                if (state.args.enemyTargetSelectorType === "randomTick") {
                    state.meta.targetId = (0, Random_1.randomElement)(container.selectLivingTargets(state.selfId, Target_1.Target.AllEnemies));
                }
            }
            case EventType_1.EventType.Damaged: {
                const { damagedBy } = e.args;
                if (state.args.enemyTargetSelectorType === "lastDamagedBy") {
                    state.meta.targetId = damagedBy;
                }
            }
        }
    }
    action(sequence, container, state) {
        let targetId = state.meta.targetId;
        const livingEnemies = container.selectLivingTargets(state.selfId, Target_1.Target.AllEnemies);
        switch (state.args.enemyTargetSelectorType) {
            case "lastDamagedBy": {
                break;
            }
            case "lowestHealth": {
                [targetId] = livingEnemies.sort((a, b) => container.getAttributeScore(a, enums_1.AttributeType.Health) - container.getAttributeScore(b, enums_1.AttributeType.Health));
                break;
            }
            case "highestHealth": {
                [targetId] = livingEnemies.sort((a, b) => container.getAttributeScore(b, enums_1.AttributeType.Health) - container.getAttributeScore(a, enums_1.AttributeType.Health));
                break;
            }
            case "random": {
                targetId = (0, Random_1.randomElement)(livingEnemies);
                break;
            }
            case "randomTick": {
                break;
            }
        }
        if (container.isDeceased(targetId)) {
            targetId = (0, Random_1.randomElement)(livingEnemies);
        }
        for (let i = 0; i < state.args.slotPriorities.length; i++) {
            const slot = state.args.slotPriorities.at(i);
            const ability = container.getAbilityInSlot(state.selfId, slot);
            if (ability && !ability.disabled) {
                let target = Target_1.Target.None;
                switch (ability.targetType) {
                    case "Self":
                        target = Target_1.Target.Self;
                        break;
                    case "OneEnemies":
                        if (container.isDeceased(targetId)) {
                            return;
                        }
                        target = Target_1.Target.OneEnemy(targetId);
                        break;
                    case "AllEnemies":
                        if (livingEnemies.length === 0) {
                            return;
                        }
                        target = Target_1.Target.AllEnemies;
                        break;
                    case "OneAllies":
                        const livingAllies = container.selectLivingTargets(state.selfId, Target_1.Target.AllAllies);
                        if (livingAllies.length === 0) {
                            return;
                        }
                        target = Target_1.Target.OneAlly((0, Random_1.randomElement)(livingAllies));
                        break;
                    case "AllAllies":
                        target = Target_1.Target.AllAllies;
                        break;
                }
                const args = AbilityArgs_1.AbilityArgs.FromTypeName(ability.abilityType, target);
                return container.useAbility(sequence, state.selfId, args, true);
            }
        }
        // Default to chopping!
        if (container.isDeceased(targetId)) {
            return;
        }
        return container.useAbility(sequence, state.selfId, AbilityArgs_1.AbilityArgs.FromTypeName("Chop", Target_1.Target.OneEnemy(targetId)), false);
    }
    nextTurn(sequence, container, state) {
        const { minActionsPerTurn = 1, maxActionsPerTurn = 1 } = state.args;
        const actionsThisTurn = minActionsPerTurn === maxActionsPerTurn ? minActionsPerTurn
            : (0, Random_1.random)(minActionsPerTurn, maxActionsPerTurn);
        for (let i = 0; i < actionsThisTurn; i++) {
            if (container.isDeceased(state.selfId)) {
                return;
            }
            else if (container.hasEffectOfType(state.selfId, EffectType_1.EffectType.Stun)) {
                return;
            }
            this.action(sequence, container, state);
        }
    }
};
BasicAi = __decorate([
    Registries_1.Ai.register("Basic")
], BasicAi);
exports.BasicAi = BasicAi;
